"use client";

import { Button, Layout, Result } from "antd";
import { useTranslations } from "@/i18n";

/**
 * Unknown URLs (the static export serves this as 404.html). Built with antd
 * so it follows the viewer's theme; Next's default page brings its own
 * colours and stayed white in dark mode.
 */
export default function NotFound() {
	const t = useTranslations("notFound");
	return (
		<Layout className="min-h-screen items-center justify-center p-6">
			<Result
				status="404"
				title={t("title")}
				subTitle={t("subtitle")}
				extra={
					<Button type="primary" href="/">
						{t("home")}
					</Button>
				}
			/>
		</Layout>
	);
}
